/* IMPORTS */
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import cropr from "../../../shared/utils/cropr";
import gettext from "../../../shared/utils/gettext";
import { RawDataTypes } from "./ObjectInterfaces";

/* Assigning the prop types */
interface ViewRawDataProps {
  getDisplayName: any;
  rawData: RawDataTypes;
}

/* Local type interfaces */
interface ColTypes {
  dataField: string;
  formatter: any;
  headerStyle: any;
  sort: boolean;
  text: string;
}

/* ViewRawData Component */
export const ViewRawData = ({ getDisplayName, rawData }: ViewRawDataProps) => {
  /* Iterating over the data to create a column for each measurement */
  const columns: ColTypes[] = [];

  rawData.headers.forEach((header: string) => {
    if (header === "lat" || header === "lon") {
      const col: ColTypes = {
        text: header,
        dataField: header,
        sort: false,
        formatter: (c: any, r: any) => cropr.toLocaleFixed(c, 8),
        headerStyle: { width: "150px" },
      };
      columns.push(col);
    } else {
      const headerArr: string[] = header.split("|");
      const headerName: string = getDisplayName(headerArr[1], headerArr[0].split("+")[1]);
      const col: ColTypes = {
        text: headerName,
        dataField: headerArr[0],
        sort: true,
        formatter: (c: any, r: any) => cropr.toLocaleFixed(c, 2),
        headerStyle: { width: "275px" },
      };
      columns.push(col);
    }
  });

  /* JSX */
  return (
    <ToolkitProvider
      keyField="id"
      data={rawData.points}
      columns={columns}
      bootstrap4={true}
      exportCSV={{
        fileName: "Raw_Correlation_Data.csv",
      }}
    >
      {(props) => (
        <div
          style={{
            width: `${275 * (rawData.headers.length - 2) + 300}px`,
          }}
        >
          <BootstrapTable
            {...props.baseProps}
            // @ts-ignore   [Proper TS Solution Needed]
            pagination={paginationFactory({ bootstrap4: true })}
          />
          <hr />
          <ExportCSV {...props.csvProps} />
        </div>
      )}
    </ToolkitProvider>
  );
};

/* ExportCSV component allowing the user to download the used datapoints as CSV */
const ExportCSV = (props: any) => {
  return (
    <div>
      <button
        className="btn btn-primary btn-lg"
        onClick={() => {
          props.onExport();
        }}
      >
        {gettext("Download CSV")}
      </button>
    </div>
  );
};
